module.exports = __webpack_public_path__ + "img/spider-small.3254594a.svg";